import {
  ChevronLeft as ChevronLeftIcon,
  FormatListBulleted as FormatListBulletedIcon,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";

interface ConversationHistoryButtonProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

export const ConversationHistoryButton: React.FC<
  ConversationHistoryButtonProps
> = ({ isCollapsed, onToggle }) => {
  return (
    <Tooltip title="Conversation History" placement="right" arrow>
      <IconButton
        onClick={onToggle}
        size="small"
        sx={{
          backgroundColor: "background.paper",
          border: 1,
          borderColor: "divider",
          opacity: 0.75,
          "&:hover": {
            backgroundColor: "action.hover",
            opacity: 1,
          },
        }}
      >
        {isCollapsed ? <FormatListBulletedIcon /> : <ChevronLeftIcon />}
      </IconButton>
    </Tooltip>
  );
};
